var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBloodReview = function SvgBloodReview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 15.091V8.364A5.617 5.617 0 0 1 8.375 2.75h11.25a5.617 5.617 0 0 1 5.625 5.614v7.852c0 3.094-2.52 5.603-5.625 5.603h-1.688a1.14 1.14 0 0 0-.9.45l-1.687 2.239c-.742.99-1.957.99-2.7 0l-1.688-2.24c-.18-.247-.585-.45-.9-.45H8.376c-3.105 0-5.625-2.508-5.625-5.602v-1.125Z",
    fill: "#FED0C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.625 10.344H8.375a.85.85 0 0 1-.844-.844.85.85 0 0 1 .844-.844h11.25a.85.85 0 0 1 .844.844.85.85 0 0 1-.844.844ZM15.125 15.969h-6.75a.85.85 0 0 1-.844-.844.85.85 0 0 1 .844-.844h6.75a.85.85 0 0 1 .844.844.85.85 0 0 1-.844.844Z",
    fill: "#FF6969"
  })));
};
export default SvgBloodReview;